import { buildSchema, buildProperty } from "@camberi/firecms";

export const staticPagesSchema = buildSchema({
    name: "Static Pages",
    properties: {
        title: {
            title: "title",
            dataType: "string",
            validation: { required: true },
        },
        description: {
            title: "description",
            dataType: "string",
            config: {
                markdown: true
            },
            validation: { required: true },
        },
        visibility: buildProperty({
            title: "Visibility",
            validation: { required: true },
            dataType: "string",
            columnWidth: 140,
            config: {
                enumValues: {
                    private: "Private",
                    public: "Public"
                }
            }
        }),
        status: {
            title: "status",
            dataType: "boolean"
        },
        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            validation: { required: true },

        },
        // type: {
        //     title: "Type",
        //     dataType: "string",
        //     config: {
        //         enumValues: {
        //             privacy_policy: "Privacy & Policy",
        //             term_conditions: "Terms and Conditions",
        //         }
        //     }
        // }
    },
    defaultValues: {
        status: false
    }
});
